import { render } from "./ModalDownloadDocuments.vue?vue&type=template&id=b565ddfc&scoped=true&ts=true"
import script from "./ModalDownloadDocuments.vue?vue&type=script&lang=ts"
export * from "./ModalDownloadDocuments.vue?vue&type=script&lang=ts"

import "./ModalDownloadDocuments.vue?vue&type=style&index=0&id=b565ddfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b565ddfc"]])

export default __exports__